import _ from 'lodash';
import React, { useState } from 'react';
import cx from 'classnames';
import { dayjs } from 'utils/time';


import * as Icons from 'components/Svg';
import {CircleButton} from 'components/Button';

import Modal, { ModalFullScreen, ModalHeader, ModalTitle, ModalSubtitle, ModalActions, ModalNotice } from 'components/Modal';


const ImageModal = ({ liveThumbs, index, onClose, }) => {
  const [currentIndex, setCurrentIndex] = useState(index);
  const thumb = liveThumbs[currentIndex];

  const sinceStart = dayjs.duration(thumb.sinceStart).format("HH:mm:ss");
  const created = dayjs.duration(thumb.created).format("HH:mm:ss");
  const lastThumb = _.maxBy(liveThumbs, (thumb) => thumb.created);
  const maxTime = dayjs.duration(lastThumb.sinceStart).format("HH:mm:ss");
  const imagesCount = _.size(liveThumbs);

  const handleNextImage = () => {
    setCurrentIndex((currentIndex) => (currentIndex + 1) % liveThumbs.length);
  };
  const handlePrevImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? liveThumbs.length - 1 : prevIndex - 1));
  };

  return (
    <ModalFullScreen className="g-image-modal" onRight={handleNextImage} onLeft={handlePrevImage} onClose={onClose}>
      <img src={thumb.imageUrl} alt="Modal Image" onClick={handleNextImage} />
      <div className="image-since" title={created}>{sinceStart} / {maxTime}</div>
      <div className="image-count">{currentIndex} / {imagesCount}</div>
      <CircleButton className="back" size="xl" onClick={handlePrevImage}><Icons.LeftChevronIcon /></CircleButton>
      <CircleButton className="forward" size="xl" onClick={handleNextImage}><Icons.RightChevronIcon /></CircleButton>
      <div></div>
    </ModalFullScreen>
  );
};

export default ImageModal;
